<template lang="slm">
  div
    .section.kids-img.d-flex.flex-column anchor='kids'
      .flex-grow
      .gradient
        .container
          h1.mb-3 Kids
          p Воскресной школе нашей церкви уже более 20 лет. Все начиналось когда-то в маленьком полуподвальном помещении. А сегодня в просторных ярких классах школы с новыми современными игрушками и мебелью учатся около 300 детей в возрасте от 3-х до 15 лет. Есть в церкви и специальная комната для мам и малышей с прямой трансляцией служения, где можно послушать проповедь, ни на минутку не оставляя ребенка.
    .section.boger anchor='boger'
      .gradient
        .container
          .left
            h1 BOGER
            .flex-grow
            p Каждую субботу в 15:00.
            p Возраст от 12 до 16 лет.
            p тел.: +38 (0619) 42 49 59
          .right
            p Служение подростков Boger - это хорошая возможность заложить правильный фундамент христианских принципов и приоритетов, которые помогут ребятам в будущем.
            p Встречи "богеров" не похожи на обычные служения - здесь Слово Божье и молитва сочетаются с играми, соревнованиями, квестами, тематическими вечеринками и пикниками.
    .section.youth anchor='youth'
      a.d-flex href='http://youth.mlt.church' target='_blank' rel='noopener noreferrer'
        .container
          .left
            h1 YOUTH
            .flex-grow
            p тел.: +38 (0619) 42-49-59
            p моб.: +38 (096) 695-2-695
          .right
            p YOUTH - это молодежь в возрасте от 16 лет и старше, которая хочет расти духовно, реализовать себя и помогать другим.
            p Мы встречаемся каждую субботу в церкви в 18:00 и каждый раз вас ждет что-то новенькое: это могут быть проповеди и ток-шоу на актуальные темы, общение и разбор Библии, концерты и конференции, различные совместные поездки и отдых.
    .section.woman anchor='woman'
      .container
        .left
          h1 WOMAN
          .flex-grow
          div Мы собираемся регулярно, приходи и ты сможешь стать частью нашей большой семьи и быть нам драгоценной сестрой. Информацию о проходящих собраниях ты можешь узнать на стойке регистрации в фойе Церкви.
        .right
          p Женское служение – это служение для девушек и женщин любого возраста. Мы собираемся, чтобы подружиться и помочь друг другу построить взаимоотношения с Богом, семьей и окружающими людьми.
          p Мы хотим вдохновить тебя использовать свой потенциал и способности, чтобы сделать наши семьи, нашу церковь, наш город и страну лучше…
          p Начиная с себя, любя Бога и ближнего, мы можем принести изменения вокруг нас!!!
          p Темы наших собраний: Библия о женщинах, Семейные отношения, Воспитание детей, Красота, здоровье, Хобби, рукоделие, Финансы, Благотворительность, Духовный рост и служение
</template>

<style lang="stylus" scoped>
h1
  font-size 83px
  font-weight 800 !important
  @media (max-width: 767.98px)
    text-align left
    font-size 56px

p
  font-size 20px !important
  font-weight 500 !important

text-section()
  min-height 500px
  display flex
  flex-direction column
  justify-content flex-end
  .container
    margin-top 24px
    margin-bottom 24px
    display flex
    align-items stretch
    > .left
      display flex
      flex-direction column
      margin-right 24px
      h1
        text-shadow 0 20px 25px rgba(0,0,0,36%)
        white-space nowrap
      p
        font-weight 700 !important
        margin-bottom 0.25rem !important
        white-space nowrap
      p
      div
        font-size 24px
        text-align right
        text-shadow 0 3px 25px rgba(0,0,0,80%)
    > .right
      display flex
      flex-direction column
      p
        text-align left
        text-shadow 0 3px 25px rgba(0,0,0,80%)
      p:last-child
        margin-bottom 0
    @media (max-width: 767.98px)
      flex-direction column
      > .left
        h1
        p
        div
          text-align left
          white-space normal

bg-image()
  background-position center
  background-repeat no-repeat
  background-size cover
  background-attachment fixed
  @supports (-webkit-overflow-scrolling: touch) {
    // iOS
    background-attachment scroll
  }

.section
  padding-top 48px
  background-color dark-color
  color light-color
  &.header
    background-color dark-color
  &.kids-img
    min-height 500px
    background-image linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~img/bg/kids.png')
    bg-image()
    background-position top center
  &.boger
    background-image linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~img/bg/boger.jpg')
    bg-image()
    background-position 70% 60%
    text-section()
  // &.youth-img
  //   min-height 500px
  //   max-height 100vh
  //   background-image url('~img/bg/youth.jpg')
  //   background-position top center
  //   background-repeat no-repeat
  //   background-size cover
  //   a
  //     display flex
  //     justify-content center
  //     align-items center
  //     position absolute
  //     top 0
  //     left 0
  //     right 0
  //     bottom 0
  //     text-shadow 0 20px 25px rgba(0,0,0,36%)
  &.youth
    background-image linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~img/bg/youth.jpg')
    bg-image()
    text-section()
  &.woman
    background-image linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~img/bg/woman.jpg')
    bg-image()
    background-position 40% 50%
    text-section()

.gradient
  width 100%
  background linear-gradient(transparent, rgba(0, 0, 0, 0.5))
</style>

<script>
export default {
  name: 'ServicesPage',
  mounted() {
    this.$_scrollToAnchor();
  },
};
</script>
